// 在main.js上通过import引入Vue库和自己写的Vue组件库
import Vue from 'vue';
import 'element-ui/lib/theme-chalk/index.css'
import element from './element/index'

Vue.use(element)

import IntvTimeCale from './components/IntvTimeCale.vue';
import eventBus from "../../../../../../util/eventBus";
import {utils} from "./common/common";

(function (KDApi) {
    function MyComponent(model) {
        this._setModel(model)
    }

    MyComponent.prototype = {
        _setModel: function (model) {
            this.model = model
        },
        init: function (props) {
            console.log('-----init', this.model.style, props)
            setHtml(this.model, props)
        },
        update: function (props) {
            // updateHtml(this.model, props)
            eventBus.pub(this.model, 'update', props)
        },
        destoryed: function () {
            console.log('-----destoryed', this.model)
        }
    }

    const setHtml = (model, props) => {
        KDApi.loadFile('./css/index.css', model, () => {
            const {invoke, dom} = model
            Vue.prototype.getLangMsg = (key, configObj) => {
                return KDApi.getLangMsg(model, key, configObj)
            }
            Vue.prototype.getZeroTime = (val) =>{
                let time = val ? new Date(val) : new Date();
                return new Date(time.getFullYear() + '/' + (time.getMonth()+1) + '/' + time.getDate()).getTime();
            }
            Vue.prototype.dateFormat = utils.dateFormat;
            Vue.prototype.invoke = (eventName, args)=>{
                invoke(eventName, args)
            }
            new Vue({
                el: model.dom,
                template: '<IntvTimeCale :invoke="invoke" :cusParam_updateDateRange="cusParam_updateDateRange" :cusParam_specialIntvTimeData="cusParam_specialIntvTimeData" :cusParam_specialCanOp="cusParam_specialCanOp" :cusParam_isAutoSave="cusParam_isAutoSave" :cusParam_save="cusParam_save" :themeNum="themeNum" :lang="lang" />',
                components: {
                    IntvTimeCale
                },
                data: {
                    cusParam_specialIntvTimeData:{},
                    cusParam_specialCanOp:true,
                    cusParam_isAutoSave:false,
                    cusParam_updateDateRange:null,
                    cusParam_save:0,  // 字段值改变触发保存
                    themeNum: "#5582F3",
                    lang: "zh_CN",
                },
                destoryed() {
                    console.log('Vue destory')
                },
                mounted() {
                    if(props.themeNum){this.themeNum = props.themeNum;}
                    if(props.lang){this.lang = props.lang;}
                    if(!props.data){return}
                    if(props.data.hasOwnProperty('cusParam_specialIntvTimeData')){
                        this.cusParam_specialIntvTimeData = props.data.cusParam_specialIntvTimeData ? JSON.parse(props.data.cusParam_specialIntvTimeData) : {};
                    }
                    if(props.data.hasOwnProperty('cusParam_specialCanOp')){
                        this.cusParam_specialCanOp = JSON.parse(props.data.cusParam_specialCanOp);
                    }
                    if(props.data.hasOwnProperty('cusParam_isAutoSave')){
                        this.cusParam_isAutoSave = JSON.parse(props.data.cusParam_isAutoSave);
                    }
                    this.updateSub = eventBus.sub(model, 'update', (props) => {
                        if(props.themeNum){this.themeNum = props.themeNum;}
                        if(!props.data){return}
                        if(props.data.hasOwnProperty('cusParam_specialIntvTimeData')){
                            this.cusParam_specialIntvTimeData = props.data.cusParam_specialIntvTimeData ? JSON.parse(props.data.cusParam_specialIntvTimeData) : {};
                        }
                        if(props.data.hasOwnProperty('cusParam_specialCanOp')){
                            this.cusParam_specialCanOp = JSON.parse(props.data.cusParam_specialCanOp);
                        }
                        if(props.data.hasOwnProperty('cusParam_isAutoSave')){
                            this.cusParam_isAutoSave = JSON.parse(props.data.cusParam_isAutoSave);
                        }
                        if(props.data.hasOwnProperty('cusParam_save')){
                            this.cusParam_save = JSON.parse(props.data.cusParam_save);
                        }
                        if(props.data.hasOwnProperty('cusParam_updateDateRange')){
                            this.cusParam_updateDateRange = JSON.parse(props.data.cusParam_updateDateRange);
                            console.log(this.cusParam_updateDateRange,props.data.cusParam_updateDateRange)
                        }

                    })

                },
                methods: {
                    invoke: function (eventName, args) {
                        invoke(eventName, args)
                    }
                }
            })
        })
    }

    // 注册自定义组件
    KDApi.register('setSpecialIntvTime', MyComponent, {
        isMulLang: true
    })
})(window.KDApi)
